import * as React from 'react';
import styled from '@emotion/styled/macro';
import { Flex, Heading, IconButton, theme } from "@chakra-ui/react";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";

const DayPickerWrapperBase = styled.div`
  .DayPicker {
    display: inline-block;
    outline: 0;
  }

  .DayPicker-wrapper {
    position: relative;
    user-select: none;
    padding-bottom: 1rem;
    flex-direction: row;
    outline: 0;
  }

  .DayPicker-Months {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .DayPicker-Month {
    display: table;
    border-collapse: collapse;
    border-spacing: 0;
    user-select: none;
  }

  .DayPicker-NavBar {
    padding: 0.86rem;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
  }

  .DayPicker-NavButton {
    position: absolute;
    cursor: pointer;
    top: 1rem;
    right: 1.5rem;
    margin-top: 2px;
    width: 1.25rem;
    height: 1.25rem;
    display: inline-block;
    background-size: 50%;
    background-repeat: no-repeat;
    background-position: center;
  }

  .DayPicker-NavButton:hover {
    opacity: 0.8;
  }

  .DayPicker-NavButton--interactionDisabled {
    display: none;
  }

  .DayPicker-Weekdays {
    margin-top: 1rem;
    display: table-header-group;
  }

  .DayPicker-WeekdaysRow {
    display: table-row;
  }

  .DayPicker-Weekday {
    display: table-cell;
    padding: 0.94rem 1.04rem;
    font-size: 0.875em;
    text-align: center;
  }

  .DayPicker-Weekday abbr[title] {
    border-bottom: none;
    text-decoration: none;
  }

  .DayPicker-Body {
    display: table-row-group;
  }

  .DayPicker-Week {
    display: table-row;
  }

  .DayPicker-Day {
    display: table-cell;
    padding: 0.94rem 1.04rem;
    text-align: center;
    cursor: pointer;
    vertical-align: middle;
    outline: none;
  }

  .DayPicker-WeekNumber {
    display: table-cell;
    padding: 0.5rem;
    text-align: right;
    vertical-align: middle;
    min-width: 1rem;
    font-size: 0.75em;
    cursor: pointer;
  }

  .DayPicker--interactionDisabled .DayPicker-Day {
    cursor: default;
  }

  .DayPicker-Footer {
    padding-top: 0.5rem;
  }

  .DayPicker-TodayButton {
    border: none;
    background-image: none;
    background-color: transparent;
    box-shadow: none;
    cursor: pointer;
    font-size: 0.875em;
  }

  /* Default modifiers */

  .DayPicker-Day--today {
    font-weight: 700;
  }

  .DayPicker-Day--outside {
    cursor: default;
  }

  .DayPicker-Day--disabled {
    cursor: default;
  }

  /* Example modifiers */

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
    position: relative;
    border-radius: 4px;
  }

  .DayPicker:not(.DayPicker--interactionDisabled)
    .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
    border-radius: 4px;
  }

  /* DayPickerInput */
  .DayPickerInput-OverlayWrapper {
    position: relative;
  }

  .DayPickerInput-Overlay {
    left: ${(props:any) => (props.center ? '-60px' : '0')};
    z-index: 12;
    position: absolute;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    margin-top: 6px;
    overflow: auto;
  }
`;


export const DayPickerWrapper = styled(DayPickerWrapperBase)`
  .DayPicker-NavBar {
    background-color: ${theme.colors.blue["300"]};
  }

  .DayPicker-NavButton {
    color: ${theme.colors.black};
  }

  .DayPicker-Weekday {
    background-color: ${theme.colors.blue["300"]};
  }

  .DayPicker-WeekNumber {
    color: #8b9898;
    border-right: 1px solid #eaecec;
  }

  .DayPicker-TodayButton {
    color: #4a90e2;
  }

  /* Default modifiers */

  .DayPicker-Day--today {
    color: ${theme.colors.blue["700"]};
  }

  .DayPicker-Day--outside {
    color: #8b9898;
  }

  .DayPicker-Day--disabled {
    color: #dce0e0;
  }

  /* Example modifiers */

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
    color: #f0f8ff;
    background-color: ${theme.colors.blue["500"]};
  }

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
    background-color: ${theme.colors.blue["500"]};
  }

  .DayPicker:not(.DayPicker--interactionDisabled)
    .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
    background-color: #f0f8ff;
  }

  .DayPickerInput-Overlay {
    background: ${theme.colors.white};
  }
`;

export const DayPickerNavBar = ({ month, nextMonth, previousMonth, onPreviousClick, onNextClick, className, localeUtils }) => {
  const months = localeUtils.getMonths();
  return (
    <Flex justifyContent="space-between" alignItems="center" className={className}>
      <IconButton aria-label="Previous month" size="md" onClick={() => onPreviousClick()} type="button" icon={<HiChevronLeft />}/>
      <Heading as="h5" fontSize="lg" >
        {months[month.getMonth()]} {month.getFullYear()}
      </Heading>
      <IconButton aria-label="Next month" size="md" onClick={() => onNextClick()} type="button" icon={<HiChevronRight />}/>
    </Flex>
  );
};